import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const FavouritesBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const favourites = useStore(state => state.favourites)
  const setFavourites = useStore(state => state.setFavourites)

  const selectedFavourite = useStore(state => state.selectedFavourite)
  const setSelectedFavourite = useStore(state => state.setSelectedFavourite)

  // const addFavourite = useStore(state => state.addFavourite)
  console.log(favourites)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)
  const favouritesActive = useStore(state => state.favouritesActive)
  // const removeFavourite = useStore(state => state.removeFavourite)

  const state = {
    favourites: favourites,
    favouritesActive: favouritesActive,
    selectedFavourite: selectedFavourite
  }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-favouritestzustand", 1000)
    if (role === "recipient") {
      socket.current.on("favouritestzustand", actAptZustand => {
        setFavourites(actAptZustand.favourites)
        setFavouritesActive(actAptZustand.favouritesActive)
        setSelectedFavourite(actAptZustand.selectedFavourite)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("favouritestzustand", state)
    }
  }, [state, role, url])

  return null
}

FavouritesBroadcaster.propTypes = {}

export default FavouritesBroadcaster
